import { PortalInviteControls } from '../../../components/common/PortalInviteControls.jsx';

export function InviteTab({ engagement, event, speaker, onUpdate }) {
  return (
    <PortalInviteControls
      engagement={engagement}
      event={event}
      speaker={speaker}
      onUpdate={onUpdate}
    />
  );
}
